































import Vue from 'vue';
// import contact, { Contact } from '@/modules/contact/contact';
import contact, { Contact } from '@/modules/contact/contact';

interface DataType {
  contacts: Contact[] | null;
  emptyText: string;
}

export default Vue.extend({
  name: 'buyer-contact-list',
  data(): DataType {
    return {
      contacts: null,
      emptyText: `お問い合わせはありません。
      展示会からお気に入りのブランドにお問い合わせしましょう。`,
    };
  },
  methods: {
    async fetchContact() {
      try {
        this.$loading(true);
        const res = await contact.loadsByBuyer(this.$auth.cid);
        this.contacts = res;
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.$loading(false);
      }
    },
    toTopPage() {
      window.location.href = '/ssr/';
    },
    onClickListItem(id: string) {
      this.$router.push({ name: 'buyer-contact-chat', params: { id } });
    },
  },
  async mounted() {
    await this.fetchContact();
  },
});
